import logo from "../assets/vodafone-logo-icon.svg";
import { Typography } from "@mui/material";

const MaintenancePage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <img src={logo} alt="Vodafone Logo" width={100} height={100} />
      <Typography
        variant="h2"
        component="div"
        sx={{ fontWeight: "bold", fontSize: "2rem", my: 3 }}
      >
        We're currently under maintenance.
      </Typography>
      <Typography>Please check back later.</Typography>
    </div>
  );
};

export default MaintenancePage;
